import { Loader2 } from 'lucide-react'
import { useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { APP_ROUTES } from '../../../constants/routes'
import { useAuth } from '../../data/hooks/auth'
import { Card, CardContent, CardHeader } from '@racefront/shadcn-ui/components/ui/card'

export default function LogOut() {
  const { signOut } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const global = searchParams.get('global') === 'true'
  const redirectUri = searchParams.get('redirectUri')
  const hasLoggedOut = useRef(false)

  useEffect(() => {
    if (hasLoggedOut.current) return
    hasLoggedOut.current = true

    const performLogout = async () => {
      try {
        await signOut(global)
      } catch (error) {
        // TODO
        console.error('Sign out error, performing silent logout:', error)
      }
      setTimeout(() => {
        if (redirectUri) {
          window.location.replace(redirectUri)
        } else {
          navigate(APP_ROUTES.SignIn)
        }
      }, 1000)
    }
    performLogout()
  }, [signOut, navigate, redirectUri, global])

  return (
    <main id="main" className="relative h-screen overflow-auto p-4 sm:px-6 sm:py-4">
      <div className="absolute left-0 top-0 z-[-1] h-screen w-full overflow-hidden object-cover brightness-50 filter">
        <img className="h-full w-full object-cover" src="/auth_bg.png" alt={'runners'} />
      </div>
      <div className="mx-auto max-w-lg pt-8">
        <Card className="bg-background/80 rounded-2xl shadow-xl">
          <CardHeader>
            <img className="mx-auto" src="logo_dark.png" alt="Logo" width={100} height={100} />
          </CardHeader>
          <CardContent>
            <div className="flex w-full flex-col items-center">
              <div className="flex w-full max-w-sm flex-col items-center">
                <h3 className="text-center text-xl font-bold">
                  <FormattedMessage id="logout.message" defaultMessage="Logging out..." />
                </h3>
                <Loader2 className="mt-8 h-8 w-8 animate-spin opacity-25" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </main>
  )
}
